import { render } from "./MembersMember.vue?vue&type=template&id=5d080d90"
import script from "./MembersMember.vue?vue&type=script&lang=js"
export * from "./MembersMember.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__